/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbPlageHoraireGridDto } from './FcbPlageHoraireGridDto';
import {
    FcbPlageHoraireGridDtoFromJSON,
    FcbPlageHoraireGridDtoFromJSONTyped,
    FcbPlageHoraireGridDtoToJSON,
} from './FcbPlageHoraireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbPlageHoraireGridDtoPaginatedResults
 */
export interface FcbPlageHoraireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbPlageHoraireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbPlageHoraireGridDto>}
     * @memberof FcbPlageHoraireGridDtoPaginatedResults
     */
    results?: Array<FcbPlageHoraireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbPlageHoraireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbPlageHoraireGridDtoPaginatedResults interface.
 */
export function instanceOfFcbPlageHoraireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPlageHoraireGridDtoPaginatedResultsFromJSON(json: any): FcbPlageHoraireGridDtoPaginatedResults {
    return FcbPlageHoraireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbPlageHoraireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPlageHoraireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbPlageHoraireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbPlageHoraireGridDtoPaginatedResultsToJSON(value?: FcbPlageHoraireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbPlageHoraireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

